import apiAxios, { SYNC_TIMEOUT } from '@/services/axios/axiosConfig';

interface CallbackResponse {
  id: number;
  created_at: string;
  uuid: string;
  date: string;
  user_name: string;
  user_phone: string;
  user_email: string;
  channel_type: string;
  yclid: string | null;
  note: string;
  company: string;
  site_callback_status_type_id: number;
  site_callback_status_type: null | any; // уточнить тип, если есть
  site_callback_type_id: number;
  site_callback_type: {
    id: number;
    name: string;
    tag: string;
  };
  archived_at: string | null;
  updated_at: string | null;
}

async function callback(jsonData: object) {
  return apiAxios.post<CallbackResponse>(
    '/api/callback',
    jsonData,
    {
      timeout: SYNC_TIMEOUT,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}

export default callback;
